<template>
    <div class="pro-bim">
      <h2 class="is-size-2 has-text-weight-semibold title has-text-dark">ALLPLAN</h2>
      <h3 class="is-size-3 has-text-weight-bold title line-height">BIMPLUS</h3>
      <h4 class="is-size-5 line-height mb-3">{{ bimPlusText.headermsg }}</h4>
      <button class="button has-background-black-bis has-text-white is-medium"
        v-permission="{permissionModule: 'app&projects', type: 'thirdPartyPlugins'}"
        @click="bimPlusLogin">{{ bimPlusText.buttontxt }}
      </button>
    </div>
</template>

<script>
import { computed, reactive, toRefs } from 'vue';
import { useStore } from 'vuex';
import { isEmpty } from 'lodash';
import { useRouter } from 'vue-router';

export default ({
  name: 'BimPlusUser',
  setup() {
    const store = useStore();
    const router = useRouter();
    const state = reactive({
      isLoggedIn: false,
    });
    const bimPlusText = computed(() => {
      let headermsg = 'Enable BIMPLUS to connect and view models and drawings.Changes will take effect immediately';
      let buttontxt = 'Enable BIMPLUS';

      if (!isEmpty(store.state.bimplus.access_token)) {
        headermsg = 'BIMPLUS enabled.You can now connect and view models and drawings.';
        buttontxt = 'Reauthorize Token/Change Linked Account';
      }
      return { headermsg, buttontxt };
    });
    const bimPlusLogin = () => {
      router.push({ name: 'bimplus-authorize', params: { oauth: 'authorize' } });
    };
    return {
      ...toRefs(state),
      bimPlusText,
      bimPlusLogin,
    };
  },
});
</script>